export default __webpack_public_path__ + "static/media/MOONBASE.62b0b313.png";